import styled from "styled-components";
import { Switch } from "antd";
import { theme } from "theme/theme";
import { Modal } from "components";

export const WrapperContractInformation = styled.div`
  margin-bottom: 40px;
`;

export const WrapperTable = styled.div`
  margin-bottom: 16px;
  overflow: auto;
  > div {
    width: 769px;
  }
  ${theme.media.tablet} {
    > div {
      width: unset;
    }
  }
`;

export const Title = styled.div`
  padding: 9px 16px;
  background: ${theme.colors.background};
  font-weight: ${theme.fontWeight.bold};
  font-size: ${theme.sizes.md};
  line-height: ${theme.sizes.md};
  color: #4f4f4f;
  border: 1px solid ${theme.colors.border};
`;

export const Row = styled.div`
  display: flex;
  //   border: 1px solid ${theme.colors.border};

  div {
    font-size: ${theme.sizes.md};
    line-height: 20px;
  }

  > div:first-child {
    background: #fbfbfb;
    padding: 9px 0px 9px 16px;
    border: 1px solid ${theme.colors.border};
    min-width: 175px;
    font-size: ${theme.sizes.md};
    line-height: 20px;
  }

  > div:last-child {
    width: 100%;
  }

  .pd {
    padding: 9px 0px 9px 16px;
    border-top: 1px solid ${theme.colors.border};
    border-right: 1px solid ${theme.colors.border};
    border-bottom: 1px solid ${theme.colors.border};
  }

  .bg {
    background: #ffffff !important;
    border-left: none !important;
  }
`;

export const WrapperGroupButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${theme.media.tablet} {
    flex-direction: row;
  }
`;

export const WrapperAutoUnlinkSetting = styled.div`
  margin-bottom: 40px;
  > .form {
    padding: 16px;
    border: 1px solid #cccccc;
  }
  button:first-child {
    margin-bottom: 16px;
  }
  button:last-child {
    margin-top: 16px;
  }
  ${theme.media.tablet} {
    > .form {
      padding: 16px 16px 24px;
      display: flex;
      gap: 32px;
      border: 1px solid ${theme.colors.border};
      button:last-child {
        height: 31px;
      }
      .ant-switch-checked {
        background: #2ac769;
      }
    }
    button:last-child {
      margin-top: 0;
    }
  }
`;

export const WrapperPaymentInformation = styled.div`
  overflow: auto;
  > div {
    width: 769px;
  }
  ${theme.media.tablet} {
    > div {
      width: unset;
    }
  }
`;

export const WrapperRow = styled.div`
  display: flex;
  div {
    padding: 10px 0px 10px 16px;
    border: 1px solid #cccccc;
    font-size: 16px;
    line-height: 20px;
    font-weight: ${theme.fontWeight.regular};
  }
  div:first-child {
    min-width: 90px;
  }
  div:nth-child(2) {
    min-width: 151px;
  }
  div:nth-child(3) {
    min-width: 115px;
  }
  div:nth-child(4) {
    min-width: 101px;
  }
  > div:last-child {
    width: 100%;
  }
`;

export const WrapperData = styled.div``;

export const ModalStyled = styled(Modal)`
  .ant-modal-header {
    background: #fbfbfb;
    padding: 16px;
  }
  .ant-modal-body {
    background: #fbfbfb;
    padding: 16px 16px 16px;
    border-radius: 12px;
  }
  ${theme.media.tablet} {
    .ant-modal-body {
      padding: 16px 24px 24px;
    }
    .ant-modal-header {
      padding: 23px 24px;
    }
  }
`;

export const WrapperSendMessageBtn = styled.div`
  button {
    width: 100%;
    padding: 9px 0 8px;
  }

  button:last-child {
    margin-bottom: 24px;
    order: 1;
  }
  button:first-child {
    order: 2;
  }

  display: flex;
  flex-direction: column;

  ${theme.media.tablet} {
    justify-content: space-between;
    flex-direction: row;
    width: unset;
    button {
      width: unset;
      padding: 8px 88px 9px;
    }
    button:last-child {
      margin-bottom: 0;
      order: 2;
    }
    button:first-child {
      order: 1;
    }
  }
`;

export const SwitchStyled = styled(Switch)`
  background-color: #e0e0e0;
`;

export const WrapperErrorMessage = styled.div`
  position: absolute;
  bottom: -6px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  position: absolute;
  display: block;
  background: ${theme.colors.white};
  color: ${theme.colors.error};
  font-size: ${theme.sizes.sm};
  font-weight: ${theme.fontWeight.regular};
  line-height: 16px;
  padding: 9px 8px;
  z-index: 100;
  border-radius: 8px;
  border: 1px solid ${theme.colors.error};
  transform-origin: 50% 89.9943px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.16);
  width: max-content;
  &::after {
    content: "";
    position: absolute;
    top: -5px;
    left: 18px;
    height: 7px;
    width: 7px;
    background: ${theme.colors.error};
    transform: rotate(45deg);
  }
  &::before {
    content: "";
    position: absolute;
    top: -4px;
    left: 17px;
    width: 6px;
    height: 10px;
    background: ${theme.colors.white};
    transform: rotate(45deg);
    z-index: 1;
  }
`;
